<template>
<div>
    <zm-row>
        <zm-button size="small" @click="showCreate()" class="btn-in-line" type="primary" v-if="hasPermission">Create Group</zm-button>
        <zm-button size="small" @click="fetchData()" plain class="btn-in-line">Show All</zm-button>
    </zm-row>
    <zm-table :data="list" v-loading="loading">
      <zm-table-column type="expand">
        <template slot-scope="scope">
          <topic :userName="userName" :groupName="scope.row.name"></topic>
        </template>
      </zm-table-column>
      <zm-table-column prop="name" label="name"></zm-table-column>
      <zm-table-column prop="clientParameterName" label="clientParameterName"></zm-table-column>
      <zm-table-column width="160px">
        <template slot-scope="scope">
          <zm-button type="icon" icon="zm-icon-edit" @click="showEdit(scope.row)"></zm-button>
          <zm-button type="icon" icon="zm-icon-delete" @click="deleteGroup(scope.row.id)"></zm-button>
        </template>
      </zm-table-column>
    </zm-table>
  <div style="text-align: center" class="pagination-wrap">
    <zm-pagination @current-change="fetchData"
                   @size-change="handleSizeChange"
                   :current-page.sync="pageable.page" :page-size="pageable.size"
                   :page-sizes="[10, 20, 50, 100, 500, 1000]"
                   layout="sizes, total, prev, pager, next, jumper"
                   :total="list.length">
    </zm-pagination>
  </div>
  <zm-dialog :title="form.id ? 'Edit Group' : 'Create Group'" :visible.sync="visible">
    <zm-form :model="form" :rules="rules" ref="form" label-width="160px">
      <zm-form-item prop="groupName">
        <div slot="label">
          <tip label="Group" id="user-producerGroup-groupName"></tip>
        </div>
        <zm-input size="small" v-model="form.groupName"></zm-input>
      </zm-form-item>
      <zm-form-item prop="clientParameterId">
        <div slot="label">
          <tip label="Client Parameter" id="user-producerGroup-clientParameterId"></tip>
        </div>
        <zm-select size="small" v-model="form.clientParameterId" clearable filterable>
          <zm-option v-for="item in producerClient" :key="item.id" :value="item.id" :label="item.name"></zm-option>
        </zm-select>
      </zm-form-item>
    </zm-form>
    <div slot="footer" class="dialog-footer">
      <zm-button size="small" @click="visible = false">Cancel</zm-button>
      <zm-button size="small" type="primary" @click="save()" :loading="loading">Save</zm-button>
    </div>
  </zm-dialog>
</div>
</template>
<script>
import { listClient } from '@/api/clientparam'
import { addGroup, deleteGroup, listGroup, updateGroup } from '@/api/group'
import tip from 'components/ToolTip/index'
import Topic from './topic'

export default {
  name: 'producerGroup',
  components: {
    tip,
    Topic
  },
  data () {
    return {
      hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
      userName: '',
      producerClient: [],
      loading: false,
      list: [],
      visible: false,
      form: {
        id: '',
        clientParameterId: '',
        groupName: '',
        userName: ''
      },
      rules: {
        clientParameterId: [
          { required: true, message: 'please select a clientParameter', trigger: 'blur' }
        ],
        groupName: [
          { required: true, message: 'please enter group name', trigger: 'blur' }
        ]
      },
      pageable: {
        page: 1,
        size: 10,
        total: 0
      }
    }
  },
  created () {
    if (localStorage.params && localStorage.params !== 'undefined' && localStorage.path === this.$route.path) {
      this.pageable.page = JSON.parse(localStorage.params).page
      this.pageable.size = JSON.parse(localStorage.params).size
    }
        localStorage.params = ''
        localStorage.path = this.$route.path
        this.userName = this.$route.params.userName
        this.fetchData()
        this.fetchClient()
    },
    watch: {
        'pageable.page' () {
            this.setURL()
        },
        'pageable.size' () {
            this.setURL()
        }
    },
    methods: {
        handleSizeChange (val) {
            this.pageable.pageSize = val
            this.fetchData()
        },
        setURL () {
            const { page, size } = this.pageable
            const data = { path: this.$route.path, page, size }
            localStorage.params = JSON.stringify(data)
        },
        fetchClient () {
            listClient('PRODUCER').then(response => {
                this.producerClient = response
            })
        },
        fetchData () {
            this.loading = true
            listGroup(this.userName).then(response => {
                this.loading = false
                this.list = response
            }).catch(() => {
                this.loading = false
            })
        },
        showCreate () {
          this.form.id = ''
          this.form.clientParameterId = ''
          this.form.groupName = ''
          this.form.userName = this.userName
          this.visible = true
        },
        showEdit (row) {
          this.form.id = row.id
          this.form.clientParameterId = row.clientParameterId
          this.form.groupName = row.name
          this.form.userName = row.userName
          this.visible = true
        },
        save () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                  this.loading = true
                  const { id, userName, groupName, clientParameterId } = this.form
                  const data = { userName, groupName, clientParameterId }
                  if (!this.form.id) {
                    addGroup(data).then(response => {
                      this.fetchData()
                      this.$message({
                        message: 'Add group success!',
                        type: 'success'
                      })
                      this.visible = false
                      this.$refs.form.resetFields()
                    }).catch(() => {
                      this.loading = false
                    })
                  } else {
                    updateGroup(id, data).then(response => {
                      this.fetchData()
                      this.$message({
                        message: 'Edit group success!',
                        type: 'success'
                      })
                      this.visible = false
                      this.$refs.form.resetFields()
                    }).catch(() => {
                      this.loading = false
                    })
                  }
                } else {
                    this.$message({
                        message: 'Submit error!',
                        type: 'error'
                    })
                    return false
                }
            })
        },
        deleteGroup (id) {
            this.loading = true
            this.$confirm('This will delete the group. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteGroup(id).then(response => {
                    this.fetchData()
                    this.$message({
                        message: 'Delete success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        }
    }
}
</script>
